import { Vue, newVue, initVue } from '@/config/vue'

initVue({
  controller: 'profiles',
  init() {
    const Profile = Vue.component('profile', () =>
      import(/* webpackChunkName: "account-profile" */ './Profile/Profile.vue')
    )
    newVue({
      render: h => h(Profile),
      mount: '.js-vue-account-profile',
    })
  },
})

initVue({
  controller: 'orders',
  action: 'index',
  init() {
    const Orders = Vue.component('orders', () =>
      import(/* webpackChunkName: "account-orders" */ './Orders/Orders.vue')
    )
    newVue({
      render: h => h(Orders),
      mount: '.js-vue-account-orders',
    })
  },
})

initVue({
  controller: 'store_credits',
  action: 'index',
  init() {
    const StoreCredits = Vue.component('store_credits', () =>
      import(/* webpackChunkName: "account-store-credits" */ './StoreCredits/StoreCredits.vue')
    )
    newVue({
      render: h => h(StoreCredits),
      mount: '.js-vue-account-store-credits',
    })
  },
})
